"use client"

import { sendGTMEvent } from "@next/third-parties/google"

import type { StoreProduct, StoreProductVariant } from "@/platform/api/store-contract"

// The GTM → Facebook Pixel ViewContent integration matches on these exact legacy
// camelCase keys (see ProductActions.tsx getAnalyticsPayload) — do not rename fields.
const buildPdpGtmPayload = (product: StoreProduct, variant: StoreProductVariant | undefined) => ({
  productId: product.id,
  variantId: variant?.id,
  originalPrice: variant?.original_price,
  calculatedPrice: variant?.calculated_price,
  productCategories: product.categories?.map((category) => category.name),
  productCollection: product.collection?.handle,
  in_stock: product.variants.some((v) => (v.inventory_quantity || 0) > 0 || v.allow_backorder),
})

export const sendPdpGtmViewEvents = (product: StoreProduct, variant: StoreProductVariant | undefined): void => {
  const payload = buildPdpGtmPayload(product, variant)
  sendGTMEvent({ event: "product_page_view", ...payload })
  sendGTMEvent({ event: "product_variant_view", ...payload })
}
